import { EJTypes } from '../../../cimsPage/instances/ej'
import { Types } from '../../common'

const types = Types({
  page: EJTypes,
  create: 'DD648192-0B2D-4BD9-9F41-C615902EA750',
  view: '3FF9BBE5-A674-46C9-85AA-092E784077F9',
  edit: '47517A55-BABC-416F-90D4-C7909A324C6A',
  removeRestore: '4CBCF780-AF5F-456F-8F04-DF47EEBC45E3',
})

export const CreateEJType = types.Create
export const ViewEJType = types.View
export const EditEJType = types.Edit
export const RemoveRestoreEJType = types.RemoveRestore

export type EJTypePermission =
  | typeof CreateEJType
  | typeof ViewEJType
  | typeof EditEJType
  | typeof RemoveRestoreEJType
